<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qxV73I/image/cover.jpg?1704390460049" alt="This image is the cover for the book Moon of Israel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moon of Israel
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An Egyptian prince and a Hebrew woman find love and adventure in this dramatic take on the classic Exodus tale from the author of <i>King’s Solomon’s Mines</i>.</b></p><p> Ana, a scribe on his deathbed, narrates this tale of ancient Egypt and the biblical Exodus of the Hebrews. Ana tells of his childhood friend, Prince Seti, heir apparent to the pharaoh, and his travails. First, he is forced to marry his cousin. Then, his father disinherits him for thwarting his wishes to execute the Hebrews. Amid all of that, Seti meets Merapi, a Hebrew woman known as “Moon of Israel,” and a romance blossoms . . . </p> As the story progresses, the Egyptians and Hebrews face internal struggles as well as conflicts with each other. The plagues arise, and the new pharaoh hungers for revenge. Through it all, Seti learns more about himself and what it means to be a real leader.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Rider Haggard
      </h2>
      
      <p class="authorDescription body article">H. Rider Haggard (1856&ndash;1925) was an English adventure novelist. Haggard studied law, but rather than pursuing a legal career took a secretarial position in what is now South Africa. His time there provided the inspiration for some of his most popular novels, including <I>She</I> (1887), an early classic of the lost world fantasy genre and one of the bestselling books of all time.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72064130